'use client'

import { sortSizesFromStrings } from '@/lib/helpers/sort-size.helper'
import { cn } from '@/lib/utils'
import { SizeList } from '@/types/collection'
import { useEffect, useMemo, useState } from 'react'

type Props = {
  onFilterChange: (values: string[]) => void
  defaultValue?: string[]
  sizeList: SizeList
}

export const FilterSizes = ({
  onFilterChange,
  defaultValue,
  sizeList,
}: Props) => {
  const [selectedSizes, setSelectedSizes] = useState<string[]>(
    defaultValue || []
  )

  useEffect(() => {
    setSelectedSizes(defaultValue || [])
  }, [defaultValue])

  const handleSizeClick = (size: string) => {
    const sizeLower = size.toLowerCase()
    const newSizes = selectedSizes.includes(sizeLower)
      ? selectedSizes.filter((s) => s !== sizeLower)
      : [...selectedSizes, sizeLower]
    setSelectedSizes(newSizes)
    onFilterChange(newSizes)
  }

  const sizes = useMemo(
    () => sortSizesFromStrings(Object.keys(sizeList)),
    [sizeList]
  )

  return (
    <ul className='flex flex-wrap gap-2'>
      {sizes.map((item) => (
        <FilterSizeItem
          key={item}
          title={item}
          isActive={selectedSizes.includes(item.toLowerCase())}
          onClick={() => handleSizeClick(item)}
        />
      ))}
    </ul>
  )
}

const FilterSizeItem = ({
  title,
  isActive,
  onClick,
}: {
  title: string
  isActive: boolean
  onClick: () => void
}) => {
  return (
    <li>
      <button
        onClick={onClick}
        className={cn(
          'flex w-14 cursor-pointer items-center justify-center rounded-md border bg-light px-3 py-2 text-sm uppercase leading-4.5 transition-colors ease-linear',
          isActive
            ? 'border-primary-500 bg-primary-500 text-white'
            : 'border-neutral-300 text-neutral-500 lg:hover:border-primary lg:hover:bg-primary lg:hover:text-light'
        )}
      >
        {title}
      </button>
    </li>
  )
}
